import api from './api';

export interface WaiverData {
  id: string;
  title: string;
  body: string; // Full waiver HTML text — required by WVSN-02
  version: number;
  status: string;
  publishedAt: string;
}

export interface WaiverStatusResponse {
  waiver: WaiverData | null;
  hasSigned: boolean;
}

const waiverService = {
  getWaiverStatus: async (locationId: string): Promise<WaiverStatusResponse> => {
    const response = await api.get('/member/waivers/status', {
      params: { locationId },
    });
    return response.data;
  },

  signWaiver: async (waiverId: string): Promise<any> => {
    const response = await api.post(`/member/waivers/${waiverId}/sign`);
    return response.data;
  },
};

export default waiverService;
